module.exports = __webpack_public_path__ + "img/17 Aniamtion 3-squashed.03eac69d.jpg";